export default __webpack_public_path__ + "images/B0.4eed92c.png";